(() => {
  const root = document.querySelector('[data-section-id] .blog-page') || document.querySelector('.blog-page');
  if (!root) return;

  const select = root.querySelector('[data-blog-category]');
  if (select) {
    select.addEventListener('change', () => {
      const next = select.value;
      if (next) window.location.assign(next);
    });
  }

  const form = root.querySelector('.blog-page__filters');
  const input = root.querySelector('#blog-article-search');
  const cards = [...root.querySelectorAll('[data-blog-card]')];
  const empty = root.querySelector('[data-blog-empty]');

  if (!form || !input || !cards.length) return;

  const apply = (query) => {
    const needle = query.trim().toLowerCase();
    let shown = 0;

    cards.forEach((card) => {
      const haystack = (card.getAttribute('data-blog-search') || '').toLowerCase();
      const match = !needle || haystack.includes(needle);
      card.hidden = !match;
      const item = card.closest('.blog-page__item');
      if (item) item.hidden = !match;
      if (match) shown += 1;
    });

    if (empty) empty.hidden = shown > 0;
  };

  const params = new URLSearchParams(window.location.search);
  const initial = params.get('q') || '';
  if (initial && input.value !== initial) input.value = initial;
  apply(input.value);

  input.addEventListener('input', () => apply(input.value));
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const url = new URL(window.location.href);
    const next = input.value.trim();
    if (next) url.searchParams.set('q', next);
    else url.searchParams.delete('q');
    window.history.replaceState({}, '', url);
    apply(next);
  });
})();
